/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Matching_Score_CalculatingInputs */

const en_matching_score_calculating = /** @type {(inputs: Matching_Score_CalculatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculating…`)
};

const de_matching_score_calculating = /** @type {(inputs: Matching_Score_CalculatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird berechnet…`)
};

/**
* | output |
* | --- |
* | "Calculating…" |
*
* @param {Matching_Score_CalculatingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const matching_score_calculating = /** @type {((inputs?: Matching_Score_CalculatingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matching_Score_CalculatingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_matching_score_calculating(inputs)
	return en_matching_score_calculating(inputs)
});